import { render } from "./MyAddressList.vue?vue&type=template&id=7f002294&scoped=true&bindings={\"addressList\":\"setup\",\"handleBackClick\":\"setup\",\"handleAddClick\":\"setup\",\"handleUpdateClick\":\"setup\"}"
import script from "./MyAddressList.vue?vue&type=script&lang=js"
export * from "./MyAddressList.vue?vue&type=script&lang=js"

import "./MyAddressList.vue?vue&type=style&index=0&id=7f002294&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7f002294"

export default script